let screenWidth = window.innerWidth

const flightsStyles = ((theme) => ({
  paper: {
    position: 'absolute',
    top: '25%',
    width: screenWidth <= 900 ? '90%' : '40%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
  },
  sendingPaper: {
    position: 'absolute',
    top: '25%',
    width: '20%',
    // height: '10%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    marginTop: '12%',
    padding: '2px 4px 2px 4px'
  },
  menu: {
    position: 'absolute',
    top: '25%',
    width: screenWidth <= 900 ? '90%' : '30%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
  },
  flightModalTextField: {
    width: '75%'
  },
  Success: {
    backgroundColor: '#93ff93'
  },
  Failure: {
    backgroundColor: '#ff9393'
  },
  Default: {
    backgroundColor: '#fff'
  },
  Loading: {
    backgroundColor: '#f1ff93'
  },
  root: {
    width: '100%'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  header: {
    backgroundColor: 'rgb(117,117,117,1)',
    borderRadius: '0px'
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 165,
  },
  buttonCell: {
    width: '7%'
  },
  chartOverlay: {
    position: 'relative',
    width: '100%'
  }
}));

export default flightsStyles